import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataService, UserService, OperationsService, AuthenticationService, StorageService, LoansService } from '../../_services/index';
import { FormArray, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-assigncollectionagent',
  templateUrl: './assigncollectionagent.component.html',
  styleUrls: ['./assigncollectionagent.component.css']
})
export class AssigncollectionagentComponent implements OnInit {
  request_step = '1';
  clusters:any;
  terms = false;
  @Input('loan') loan: any;
  @Input('currentUser') currentUser: any;
  @Input('repayment_mode') repayment_mode: any;
  loading = false;
  change_payment_form = {
    SECURITY_QUESTION_ANSWER: '',
    REQUEST_ID: '',
    COLLECTION_AGENT: '',
    CLUSTER:'',
    COLLECTION_INTERVAL:'',
    INCLUDE_WEEKENDS:'1'
  };
  mode_of_repayment = [
    { 'value': '1', 'display': 'Remita Inflight' },
    { 'value': '2', 'display': 'Cards' },
    { 'value': '3', 'display': 'Direct Debit Mandate' },
    { 'value': '5', 'display': 'Cheques' },
    { 'value': '4', 'display': 'Others' }
  ]
  agents:any;
  constructor(public toastr: ToastrService, public loansService: LoansService,
    public fb: FormBuilder, public operationsService: OperationsService, public storageService: StorageService) {

  }

  ngOnInit() { 
    this.change_payment_form.REQUEST_ID = this.loan.request_id;
    this.getAllPlatformClusters();
    switch(this.loan.REQUEST_PERIOD_ID){
      case "1":
        this.change_payment_form.COLLECTION_INTERVAL = 'daily';
      break;
      case "2":
        this.change_payment_form.COLLECTION_INTERVAL = 'monthly';
      break;
      case "4":
        this.change_payment_form.COLLECTION_INTERVAL = 'weekly';
      break;
    }
  }
  getAllPlatformClusters(){
    this.loading = true;
    this.operationsService.getAllPlatformClusters(this.currentUser.token)
      .subscribe(data => {
        this.loading = false;
        this.clusters = data.all_cus.a;
      });
  }
  getAllCollectionAgents(cluster){
    this.loading = true;
    this.operationsService.getCollectionAgents(this.currentUser.token, cluster)
      .subscribe(data => {
        this.loading = false;
        this.agents = data.employees.all_emp;
      });
  }
  showSuccess(message) {
    this.toastr.success(message, 'Success!');
  }

  showError(message) {
    this.toastr.error(message, 'Error');
  }

  changeTheDefaultPayment(value, valid) {

    this.loading = true;
    this.operationsService.assignCollectionAgent(this.currentUser.token, value, this.loan)
      .subscribe(data => {
        this.loading = false;
        if (data.status === true) {
          let collection = {
            creditclan_id: JSON.parse(this.currentUser.platform).PEOPLE_ID,
            cluster_id:data.data.collection.cluster_id,
            agent_assigned: value.COLLECTION_AGENT,
            borrower_name: data.data.collection.borrower_name,
            borrower_phone:  data.data.collection.borrower_phone,
            borrower_address: data.data.collection.borrower_address,
            borrower_photo: data.data.collection.borrower_photo,
            borrower_location: '1.23445-1.23845',
            borrower_payment_radius:100,
            collection_amount: data.data.collection.collection_amount ,
            collection_date: data.data.collection.collection_date ,
            installments_left: data.data.collection.installments_left ,
            collection_interval: value.COLLECTION_INTERVAL,
            creditclan_request_id: data.data.collection.creditclan_request_id
          }
          this.operationsService.sendCollectionToRepid(collection)
          .subscribe(status => {
            this.loading = false;
            this.showSuccess("Agent assigned");
            this.request_step = '2';
          });
        } else {
          this.showError(data.message)
        }
      });
  }
  getAgentsInCluster(event){
    this.getAllCollectionAgents(event.target.value)
  }
}

